import { EnvironmentProviders, Provider } from '@angular/core';
import { TitleStrategy } from '@angular/router';
import { TranslatePageTitleStrategyService } from '@services/translate-page-title-strategy/translate-page-title-strategy.service';

export const APP_PROVIDERS: (Provider | EnvironmentProviders)[] = [
  { provide: TitleStrategy, useClass: TranslatePageTitleStrategyService },
];
